"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ActionItemTooltip = require("./ActionItemTooltip");
Object.keys(_ActionItemTooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionItemTooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActionItemTooltip[key];
    }
  });
});